var rich_content_viewer_default = {
  "fontElementMap": "FtflJ",
  "wrapper": "NU3Pt",
  "pluginContainerMobile": "hF1Bd",
  "viewer": "Arwt-",
  "android": "o-x6U",
  "rootedTraversedContent": "_7KJbw",
  "atomic": "ecfVC",
  "toolbar": "zs9-q",
  "block": "_7buHs"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
